import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const API = "https://labwayscientific.com/backend/wp-json/wc/v3";
const CK = "ck_e1c36267e6a5e3cb0198558262bf2096181b4a0b";
const CS = "cs_fc900ba31d63fade2cfba415abe8a599366c20b0";

function SearchBar() {

      const dropdownStyle = {
  position: "absolute",
  top: "100%",
  left: 0,
  width: "100%",
  background: "#fff",
  border: "1px solid #ddd",
  zIndex: 999,
  maxHeight: "300px",
  overflowY: "auto"
};

const itemStyle = {
  display: "flex",
  alignItems: "center",
  padding: "8px",
  cursor: "pointer",
  borderBottom: "1px solid #eee"
};

  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  // 🔥 debounce search
  useEffect(() => {
    if (!query) {
      setResults([]);
      return;
    }

    const delay = setTimeout(() => {
      fetch(`${API}/products?search=${query}&per_page=5&consumer_key=${CK}&consumer_secret=${CS}`)
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data)) {
            setResults(data);
            setShow(true);
          } else {
            setResults([]);
          }
        });
    }, 400);

    return () => clearTimeout(delay);

  }, [query]);

  const handleSelect = (id) => {
    setShow(false);
    setQuery("");
    navigate(`/product/${id}`);
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>

      <input
        type="text"
        placeholder="Search product..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          border: "1px solid #ddd"
        }}
      />

      {/* 🔥 DROPDOWN */}
      {show && results.length > 0 && (
        <div style={dropdownStyle}>

          {results.map(item => (
            <div
              key={item.id}
              onClick={() => handleSelect(item.id)}
              style={itemStyle}
            >

              <img
                src={item.images?.[0]?.src}
                style={{ width: "40px", height: "40px", objectFit: "contain" }}
              />

              <span style={{ marginLeft: "10px" }}>
                {item.name}
              </span>

            </div>
          ))}

        </div>
      )}

    </div>
  );




}

export default SearchBar;